import { Component, OnInit, Input } from '@angular/core';
import { Store } from '@ngrx/store';
import { ApplicationState } from '@store/application-store';
import { WidgetComponent } from '@dashboards/components/widget-component/widget-component';
import { DetailsItemTypesArray } from '@details/Interfaces/details-item-types';
import { Details } from '@details/Interfaces/details';
import { ConfirmationService } from 'primeng/api';

@Component({
  selector: 'mojo-details-widget',
  templateUrl: './details-widget.component.html',
})
export class DetailsWidgetComponent extends WidgetComponent implements OnInit {

  @Input() data: DetailsItemTypesArray | Details = null;
  
  constructor(protected store: Store<ApplicationState>,
    protected confirmationService: ConfirmationService) {
    super(store, confirmationService);
  }
  
}
